import React, { useState, useEffect, useRef, useContext } from "react";
import { formatDistanceToNow } from "date-fns";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { IoIosNotifications } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import avatarSvg from "../../../../Assets/Images/avatar.svg";
import {
  FIXED_HEADER_HEIGHT,
  FIXED_SIDEBAR_WIDTH_CLOSED,
  FIXED_SIDEBAR_WIDTH_OPEN,
} from "../../../../utils/constant.utils";
import { getAllNotifications } from "../../../../libs/api/notification";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import NotificationDropdown from "./NotificationDropdown";
import LanguageSwitcher from "../../../../components/LanguageSwitcher";
import { AppContext } from "../../../../context/appContext";

export default function Header({ toggleSidebar, isSidebarOpen }) {
  const { t, isRTL } = useContext(AppContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null); // Reference for the menu
  const profileRef = useRef(null); // Reference for the profile avatar

  const navigate = useNavigate();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // Fetch Notifications
  const fetchNotifications = async () => {
    try {
      const response = await getAllNotifications();
      if (response.status === 200) {
        setNotifications(response?.data?.data || []);
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  // useEffect(() => {
  //   if (openNotificationModal) {
  //     fetchNotifications();
  //   }
  // }, [openNotificationModal]);

  // Close the menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("chatSessionId");
    navigate("/");
  };

  return (
    <section
      className={`border-b border-[#F7F7F9] flex justify-between items-center px-8 p-4 transition-all ease-in-out duration-300`}
      style={{
        position: "fixed",
        top: 0,
        [isRTL ? 'right' : 'left']: isSidebarOpen
          ? FIXED_SIDEBAR_WIDTH_OPEN
          : FIXED_SIDEBAR_WIDTH_CLOSED,
        width: isSidebarOpen
          ? `calc(100% - ${FIXED_SIDEBAR_WIDTH_OPEN}px)`
          : `calc(100% - ${FIXED_SIDEBAR_WIDTH_CLOSED}px)`,
        minWidth: isSidebarOpen
          ? `calc(100% - ${FIXED_SIDEBAR_WIDTH_OPEN}px)`
          : `calc(100% - ${FIXED_SIDEBAR_WIDTH_CLOSED}px)`,
        maxWidth: isSidebarOpen
          ? `calc(100% - ${FIXED_SIDEBAR_WIDTH_OPEN}px)`
          : `calc(100% - ${FIXED_SIDEBAR_WIDTH_CLOSED}px)`,
        minHeight: `${FIXED_HEADER_HEIGHT}px`,
        maxHeight: `${FIXED_HEADER_HEIGHT}px`,
        height: `${FIXED_HEADER_HEIGHT}px`,
        [isRTL ? 'paddingRight' : 'paddingLeft']: isSidebarOpen ? "35px" : "25px",
        backgroundColor: "white",
        zIndex: 10,
      }}
    >
      <div className="flex items-center">
        <RiBarChartHorizontalLine
          size={24}
          className="cursor-pointer hover:opacity-50"
          onClick={toggleSidebar}
        />
      </div>

      {/* Avatar, Name, and Admin */}
      <div className="flex items-center gap-4">
        {/* <NotificationDropdown
          notifications={notifications}
          open={openNotificationModal}
          setOpen={setOpenNotificationModal}
        /> */}
        <LanguageSwitcher />
        <div className="relative" ref={profileRef}>
          <img
            src={avatarSvg}
            alt="Avatar"
            className="min-w-[44px] min-h-[44px] max-w-[44px] max-h-[44px] rounded-full cursor-pointer"
            onClick={toggleMenu}
          />
          {/* Profile Menu */}
          {menuOpen && (
            <div
              ref={menuRef}
              className={`absolute ${isRTL ? 'left-0' : 'right-0'} mt-2 bg-white border rounded shadow-lg p-2 w-fit`}
            >
              {/* <div
                className="text-sm font-medium text-gray-700 cursor-pointer py-2 px-4 hover:bg-gray-100"
                onClick={() => alert("Profile Clicked")}
              >
                {t('nav.profile')}
              </div> */}
              <div
                className="text-sm font-medium text-gray-700 cursor-pointer py-0 px-4 hover:bg-gray-100"
                onClick={handleLogout}
              >
                {t('nav.logout')}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* {isNotificationLoading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      )} */}

      {/* <dialog
        id="notification_modal"
        className="modal shadow-[0px_1px_2px_0px_#0A0D120F]"
      >
        <div className="modal-box min-w-[800px] max-h-[90vh] overflow-y-hidden rounded-2xl p-0">
          <div className="p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="font-semibold text-lg">Notifications</h3>
              <button
                className="text-xl hover:text-red-500"
                onClick={() =>
                  document.getElementById("notification_modal").close()
                }
              >
                <IoClose />
              </button>
            </div>

            <div className="w-full max-h-[80vh] overflow-y-auto px-1">
              {notifications.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-40 text-center text-gray-500">
                  <p>No new notifications</p>
                </div>
              ) : (
                <div className="flex flex-col">
                  {notifications.map((notification, idx) => (
                    <div key={notification._id} className="py-2">
                      <div className="flex justify-between items-start">
                        <div>
                          <div className="text-sm font-medium text-gray-800 capitalize">
                            {notification.title}
                          </div>
                          <div className="text-sm text-gray-600">
                            {notification.body}
                          </div>
                        </div>
                        <div className="text-xs text-gray-400 whitespace-nowrap ml-4">
                          {formatDistanceToNow(new Date(notification.sentAt), {
                            addSuffix: true,
                          })}
                        </div>
                      </div>
                      {idx !== notifications.length - 1 && (
                        <hr className="mt-2 border-gray-200" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </dialog> */}
    </section>
  );
}
